import React, {useEffect, useState} from "react";
import * as reference from "../models/clientModels/data/navMenuData";
import * as interfaces from "../models/clientModels/interfaces/navList";

import {Box, Collapse, List, ListItemIcon, ListItemText} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import {useNavigate} from "react-router-dom";
import {useRecoilState, useRecoilValue} from "recoil";
import {sidebarState} from "../Recoil/Atom/SideBarAtom";
import {StyledListTitle, StyledListSubTitle} from "../styledComponents/StyledListItemButton";
import {levelSelector} from "../Recoil/Atom/authState";

const NavList = () => {
  const navigate = useNavigate();
  const [navMenu, setNavMenu] = useState<interfaces.NavMenu[]>();
  const [isOpen, setIsOpen] = useRecoilState(sidebarState);
  const userLevel = useRecoilValue(levelSelector);
  const array = reference.navMenu.length;
  const [open, setOpen] = useState<Array<boolean>>(Array(array).fill(false));

  const handleClick = (idx: number): void => {
    const copyOpen = [...open];

    if (copyOpen[idx] === true) {
      copyOpen.fill(false);
      copyOpen[idx] = false;
    } else {
      copyOpen.fill(false);
      copyOpen[idx] = true;
    }
    setOpen(copyOpen);
  };

  useEffect(() => {
    switch (userLevel) {
      case 1 || 2:
        setNavMenu(reference.superMenu);
        break;
      case 3:
        setNavMenu(reference.managerMenu);
        break;
      case 4:
        setNavMenu(reference.OfficerMenu);
        break;
      case 5:
        setNavMenu(reference.boardMenu);
        break;
    }

    // setNavMenu(reference.navMenu);
  }, []);

  return (
    <Box role="presentation">
      {navMenu?.map((item, idx) => (
        <List sx={{padding: "4px 8px"}} key={item.id}>
          <StyledListTitle onClick={() => handleClick(idx)}>
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.caption} />
            {open[idx] ? <ExpandLess /> : <ExpandMore />}
          </StyledListTitle>
          <Collapse in={open[idx]} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {item.items.map((item) => (
                <StyledListSubTitle
                  onClick={() => {
                    navigate(item.url, {state: item.state});
                    setIsOpen(false);
                  }}
                  key={item.id}
                >
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.subTitle} />
                </StyledListSubTitle>
              ))}
            </List>
          </Collapse>
        </List>
      ))}
    </Box>
  );
};

export default NavList;
